import { reactive, ref } from 'vue';

// O modal desmonta o conteúdo ao fechar (inclusive num clique fora dele).
// O rascunho fica aqui, fora do componente, para uma descrição longa não se
// perder; some ao enviar o chamado ou ao recarregar a página.
export const camposDoRascunho = reactive({
  tipo: '',
  prioridade: '',
  titulo: '',
  descricao: '',
});

export const anexosDoRascunho = ref([]);

export const limparRascunho = () => {
  Object.assign(camposDoRascunho, { tipo: '', titulo: '', descricao: '' });
  anexosDoRascunho.value = [];
};
